import { render, staticRenderFns } from "./ExactTypeHistoryPopUp.vue?vue&type=template&id=67db7a27"
import script from "./ExactTypeHistoryPopUp.vue?vue&type=script&lang=js"
export * from "./ExactTypeHistoryPopUp.vue?vue&type=script&lang=js"
import style0 from "./ExactTypeHistoryPopUp.vue?vue&type=style&index=0&id=67db7a27&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports